const state = {
    initUser: false,
    hubInfo: null,
    baromoney: null,
    userInfo: null,
    userPermission: new Set(),
};
export default state;
